<div #pageContainer class="flex flex-col w-full py-3">
    <form [formGroup]="searchForm">
        <app-table-filter [searchForm]="searchForm" class="text-primary"
            (searchTriggered)="handleSearch($event)"></app-table-filter>

        <div class="grid grid-cols-1 sm:grid-cols-3">
            <div class="flex justify-start col-span-2">
                <div class="w-19 ml-2">
                    <mat-form-field class="w-full no-bottom-gap mb-2">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                    (apply)="applySort($event)">
                </app-sort-menu>

                <button class="btn btn-outline btn-default dt-download " matTooltip="Download Records"
                    (click)="downloadAppTrackingExcel()">
                    <mat-icon class="text-primary hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                </button>
            </div>
            <div class="flex justify-end">
                <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                    (click)="setPage({ offset: dt.page.offset })">
                    <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                </button>
            </div>

            <div class="flex justify-start col-span-2">
                <span class="self-center font-medium text-gray-400 italic text-md p-2">
                    Sorting by {{ sortInfo }}
                </span>
            </div>

            <div class="flex justify-end">
                <span class="self-center font-medium text-primary text-md p-2">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-moc-application-tracking-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                Field
            </div>

            <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                Platform
            </div>

            <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                Well
            </div>

            <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                Well String
            </div>

            <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                String Indicator
            </div>

            <div [mat-sort-header]="'wellProductionStatus'" class="flex border justify-center py-4">
                Status
            </div>

            <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                Failure Date
            </div>

            <div [mat-sort-header]="'failureEquipment'" class="flex border justify-center py-4">
                Failure Equipment
            </div>

            <div [mat-sort-header]="'overdueDays'" class="flex border justify-center py-4">
                Overdue Day
                <mat-icon svgIcon="heroicons_outline:information-circle" class="ml-2 text-white"
                    matTooltip='The overdue day indicates the remaining days left for the user to raise the Management of Change (MOC)'></mat-icon>
            </div>

            <div [mat-sort-header]="'overdueDate'" class="flex border justify-center py-4">
                Overdue Date
            </div>

            <div [mat-sort-header]="'submissionStatus'" class="flex border justify-center py-4">
                MOC Issuance Status
            </div>

            <div [mat-sort-header]="'submissionDate'" class="flex border justify-center py-4">
                Validation Date
            </div>

            <div class="block border text-center py-8">
                Action
            </div>

        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-moc-application-tracking-record-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldLongName }}
                    </div>

                    <!-- Platform Long Name  -->
                    <div class="flex justify-center">
                        {{ row.platformLongName }}
                    </div>

                    <!-- Well Long Name  -->
                    <div class="flex justify-center">
                        {{ row.wellLongName }}
                    </div>

                    <!-- String Short Name  -->
                    <div class="text-center">
                        {{ row.stringShortName }}
                    </div>

                    <!-- String Indicator -->
                    <div class="block text-center">
                        {{ row.stringIndicatorShortName }}
                    </div>

                    <!-- Status -->
                    <div class="block text-center mx-2">
                        {{ row.wellProductionStatus || '-' }}
                    </div>

                    <!-- Failure Date -->
                    <div class="block text-center py-2">
                        {{ handleFormatDate(row.failureDate, false) || '-' }}
                    </div>

                    <!-- Failure Equipment -->
                    <div class="block text-center">
                        {{ row.failureEquipment || '-' }}
                    </div>

                    <!-- overdue day -->
                    <div class="block text-center">
                        {{ row.overdueDays || '-' }}
                    </div>

                    <!-- overdue date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.overdueDate, false) || '-' }}
                    </div>

                    <!-- Submission Status -->
                    <div class="block text-center mx-2" [ngClass]="{
                                    'warningBadge': row.submissionStatus == 'Open' || row.submissionStatus == 'Pending',
                                    'successBadge': row.submissionStatus == 'Closed' || row.submissionStatus == 'Active',
                              }">
                        {{ row.submissionStatus || '-' }}
                    </div>

                    <!-- Submission Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.submissionDate, false) || '-' }}
                    </div>

                    <!-- Action -->
                    <div class="block text-center">
                        <button class="btn btn-remove-bg">
                            <mat-icon (click)="view(row)" class="text-primary" [svgIcon]="'heroicons_solid:eye'"
                                matTooltip="View"></mat-icon>
                        </button>

                        <button class="btn btn-remove-bg">
                            <mat-icon (click)="manuallyCheck(row)" class="text-primary" svgIcon="fact_check"
                                matTooltip="Assign MOC Records Manually"></mat-icon>
                        </button>
                    </div>
                </div>


            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
    </div>